import TIM from 'tim-js-sdk';
// import Vue from "vue"
// var vm = new Vue()


export var userConfig = {
  userID: '',
  userSig: ''
}

//初始化tim
export function initTimListener() {
  let tim = eventHub.$tim

  // 登录成功后会触发 SDK_READY 事件，该事件触发后，可正常使用 SDK 接口
  // SDK 进入 ready 状态时触发，接入侧监听此事件，然后可调用 SDK 发送消息等 API，使用 SDK 的各项功能
  tim.off(TIM.EVENT.SDK_READY, onSdkReady)
  tim.on(TIM.EVENT.SDK_READY, onSdkReady)

  //SDK NOT READT
  tim.off(TIM.EVENT.SDK_NOT_READY, onSdkNotReady)
  tim.on(TIM.EVENT.SDK_NOT_READY, onSdkNotReady)

  // 收到推送的单聊、群聊、群提示、群系统通知的新消息，接入侧可通过遍历 event.data 获取消息列表数据并渲染到页面
  tim.off(TIM.EVENT.MESSAGE_RECEIVED, onReceiveMessage)
  tim.on(TIM.EVENT.MESSAGE_RECEIVED, onReceiveMessage)

  // SDK 群组列表更新时触发，可通过遍历 event.data 获取群组列表数据并渲染到页面
  tim.off(TIM.EVENT.GROUP_LIST_UPDATED, onGroupListUpdated) //防止重复收到消息
  tim.on(TIM.EVENT.GROUP_LIST_UPDATED, onGroupListUpdated)

  // 用户被踢下线时触发
  tim.on(TIM.EVENT.KICKED_OUT, onTimKickOut)

  // SDK内部出错
  tim.on(TIM.EVENT.ERROR, onError)

  // 会话列表更新
  tim.on(TIM.EVENT.CONVERSATION_LIST_UPDATED, onUpdateConversationList)

  tim.on(TIM.EVENT.PROFILE_UPDATED, onProfileUpdated)

  tim.off(TIM.EVENT.NET_STATE_CHANGE, onNetStateChanged)
  tim.on(TIM.EVENT.NET_STATE_CHANGE, onNetStateChanged)
}

function onNetStateChanged(event) {
  //状态状态 event.data.state
  //网络中断：disconnected
  //网络连接中：connecting
  //网络连接上了：connected

  console.log("网络状态变化了-----------------", event.data.state)
  eventHub.$emit('Tim_Sdk_NetState', event.data.state)
}

function onReceiveMessage(event) {
  console.log("获取到消息-----------------", event)
  // event.data - 存储 Message 对象的数组 - [Message]
}

function onGroupListUpdated(event) {
  // console.log("群聊消息变化-----------------", event)
  console.log(event.data);// 包含 Group 实例的数组
}

function onTimKickOut(event) {
  // 收到被踢下线通知
  // event.name - TIM.EVENT.KICKED_OUT
  // event.data.type - 被踢下线的原因，例如 :
  // TIM.TYPES.KICKED_OUT_MULT_ACCOUNT(同一帐号，多页面登录被踢)
  // TIM.TYPES.KICKED_OUT_MULT_DEVICE(同一帐号，多端登录被踢)
  // TIM.TYPES.KICKED_OUT_USERSIG_EXPIRED(签名过期)
  // TIM.TYPES.KICKED_OUT_REST_API(REST API kick 接口踢出。v2.20.0起支持)
  console.log('被踢onTimKickOut-------------------', event)
  if (event && event.data) {
    switch (event.data.type) {
      case TIM.TYPES.KICKED_OUT_MULT_ACCOUNT:
        //被踢后重新登录
        // timlogin(userConfig);
        break
      case TIM.TYPES.KICKED_OUT_USERSIG_EXPIRED:
        //userSig过期
        timLogin((type) => {
        }).then(r => {
        })
        break
    }


  }
}

function onError({data}) {
  if (data.message !== 'Network Error') {
  }
}

function onUpdateConversationList(event) {
  // console.log("获取会话+++++++++++", event)
}

function onProfileUpdated(event) {
  console.log('用户资料发生改变了的---------------', event); // 包含 Profile 对象的数组
}

function onSdkReady(event) {
  //只有登录成功的操作，SDK的ready回调才会被调用
  console.log('tim  SDK  Ready--------------------', event)
  localStorage.setItem("TimSdkReadyStatus", 1)
  eventHub.$emit('Tim_Sdk_Ready')
}

function onSdkNotReady(event) {
  console.log('tim  SDK  NotReady--------------------', event)
  localStorage.setItem("TimSdkReadyStatus", 0)
}

/**
 * @param callback函数中的type的值 0:未调用IM的login  1:调用IM的login后，登录成功了 2:调用IM的login后，登录失败了
 */
export async function timLogin(callback = (type) => {
}) {
  let tim = eventHub.$tim
  let api = eventHub.$api

  var postData = {
    head
  }
  let response = await api.getUserTimInfo(postData)
  let res = response.data
  if (res.responseStatus.ack != 0 || !res) {
    if (callback != null) {
      callback(0)
    }
    return
  }

  let data = res
  userConfig.userID = data.imAccount
  userConfig.userSig = data.userSig

  tim.login({
    userID: userConfig.userID,
    userSig: userConfig.userSig
  }) //签名串
    .then((response) => {
      if (response.data.repeatLogin === true) {
        // 标识账号已登录，本次登录操作为重复登录。v2.5.1 起支持
        // console.log(response.data.errorInfo)
      }
      console.log(res, "IM登录成功，用户IM Id:" + userConfig.userID);
      if (callback != null) {
        callback(1)
      }
    })
    .catch(error => {
      console.warn("IM登录失败:", error);
      if (callback != null) {
        callback(2)
      }
    })
}

/**
 * 加入群直播（匿名和实名都可以）
 * @param callback的type 0:加入失败 2:加入成功（目前不需要通过管理员同意）
 */
export function joinGroup(groupid, callback = (type) => {
}) {
  let tim = eventHub.$tim
  let promise = tim.joinGroup({groupID: groupid, type: TIM.TYPES.GRP_AVCHATROOM});
  promise.then(function (imResponse) {
    console.log('加入群组回调------------------', imResponse)
    if (callback != null) {
      callback(1)
    }
    switch (imResponse.data.status) {
      case TIM.TYPES.JOIN_STATUS_WAIT_APPROVAL: // 等待管理员同意
        break;
      case TIM.TYPES.JOIN_STATUS_SUCCESS: // 加群成功
        // console.log('加入群组:', imResponse.data.group); // 加入的群组资料
        break;
      case TIM.TYPES.JOIN_STATUS_ALREADY_IN_GROUP: // 已经在群中
        break;
      default:
        break;
    }
  }).catch(function (imError) {
    if (callback != null) {
      callback(0)
    }
    console.warn('joinGroup error:', imError); // 申请加群失败的相关信息
  });
}


//聊天的自定义消息类型（包含：通用消息和非通用消息）
export var MsgType = {
  TxtMsg: 'LYH:Txt', //通用消息--普通文本消息
  ImgMsg: 'LYH:Img', //通用消息--图片消息
  StatusMsg: 'LYH:Status', // 非通用消息
}

//非通用消息下的子消息（LYH:Status类型）
export var StatusMsgChildType = {
  TxtTip: 'TxtTip', // 状态消息
  Gift: 'Gift', //礼物 ,礼物的具体的子类型见GiftType
  DeleteMsg: 'DeleteMsg' //删除消息
}

export var MsgFromType = {
  ih: 'fromInternetHospital', //标识聊天消息的渠道 （聊天室发送的消息）-- 用互联网医院的
  doctor: 'fromLYHDoctor' //肿瘤医生端
}

//礼物类型
export var GiftType = {
  Flower: 1 // 送花
}

//腾讯IM的网络状态
export var TimNetState = {
  disconnected: 'disconnected',//连接中断
  connecting: 'connecting',//连接中
  connected: 'connected',//连接成功
}
